var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-plus__",
    "data-name": "icons8-plus_+",
    d: "M14,4A10,10,0,1,0,24,14,10.011,10.011,0,0,0,14,4Zm0,1.5A8.5,8.5,0,1,1,5.5,14,8.489,8.489,0,0,1,14,5.5Zm-.012,3.489a.75.75,0,0,0-.738.761v3.5H9.75a.75.75,0,1,0,0,1.5h3.5v3.5a.75.75,0,1,0,1.5,0v-3.5h3.5a.75.75,0,1,0,0-1.5h-3.5V9.75a.75.75,0,0,0-.762-.761Z",
    transform: "translate(-4 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/iconPlusCircle.ef257ca6e6b8b30c4c429d52aae1ac05.svg";
export { ForwardRef as ReactComponent };